import CampaignIdSelector from './CampaignIdSelector';

export default CampaignIdSelector;
